import { render, staticRenderFns } from "./commission-set.vue?vue&type=template&id=3bceb0be&scoped=true"
import script from "./commission-set.vue?vue&type=script&lang=ts"
export * from "./commission-set.vue?vue&type=script&lang=ts"
import style0 from "./commission-set.vue?vue&type=style&index=0&id=3bceb0be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bceb0be",
  null
  
)

export default component.exports